import Splide from '@splidejs/splide';

const EL = '.js-show'
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  new Splide( EL, {
    type: "fade",
    rewind: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    perPage: 1,
    arrows: false,
    pagination: true,
    breakpoints: {
      1024: {
        width: '100%',
      }
    }
  } ).mount();
});
